import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-560950b5")

_pushScopeId("data-v-560950b5")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "absolute w-1/2 h-1/2 bg-yellow-500 demo" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ExampleBox = _resolveComponent("ExampleBox")

  return (_openBlock(), _createBlock(_component_ExampleBox, { class: "aspect-3-2 example" }, {
    default: _withId(() => [
      _hoisted_1
    ]),
    _: 1
  }))
})